import * as React from 'react';
import axios from '../../../utils/axios';

/* ============================================================================
   Selo com o numero de avisos nao lidos, no item de menu.

   POR QUE COMPONENTE E NAO NUMERO NO NavConfig: o `NavConfig` e um array
   estatico, avaliado uma vez na importacao do modulo. Qualquer contador colocado
   ali nasceria congelado no valor do primeiro carregamento. Como `info` aceita um
   ReactNode, o componente entra no lugar do numero e busca o proprio dado.

   ELE NAO APARECE quando nao ha nada a ler - e a regra que faz o selo valer algo:
   um "0" permanente ao lado de "Avisos" e ruido que se aprende a ignorar, e no dia
   em que virar "1" ninguem percebe a diferenca.

   FALHA EM SILENCIO. Se a chamada nao responder (ou a API estiver numa versao sem
   a rota), o selo simplesmente nao existe e o menu continua funcionando. Menu nao
   e lugar de mostrar erro.

   RECONSULTA a cada 3 minutos, e nao a cada minuto: aviso e comunicado escrito a
   mao, publicado algumas vezes por semana - buscar de minuto em minuto seria
   trafego constante para um numero que quase nunca muda. A tela de avisos, quando
   aberta, ja mostra o estado real.
   ============================================================================ */

const INTERVALO_MS = 180_000;

export default function SeloAvisos() {
  const [naoLidos, setNaoLidos] = React.useState(0);

  React.useEffect(() => {
    let vivo = true;
    let timer: ReturnType<typeof setTimeout> | undefined;

    const buscar = async () => {
      try {
        const { data } = await axios.get<{ naoLidos: number }>('/avisos/contador');
        if (!vivo) return;
        const n = Number(data?.naoLidos);
        setNaoLidos(Number.isFinite(n) && n > 0 ? n : 0);
      } catch (e) {
        if (vivo) setNaoLidos(0);
      } finally {
        if (vivo) timer = setTimeout(buscar, INTERVALO_MS);
      }
    };

    buscar();
    return () => {
      vivo = false;
      clearTimeout(timer);
    };
  }, []);

  if (!naoLidos) return null;

  return (
    <span
      // `bg-danger` e nao a cor da paleta: o selo diz "tem coisa esperando por
      // voce", que e o mesmo papel do contador de notificacoes. Cor da paleta aqui
      // se misturaria ao proprio destaque do item ativo.
      className="ml-auto grid h-[18px] min-w-[18px] flex-none place-items-center rounded-full bg-danger px-1 text-[10px] font-bold tabular-nums text-white"
      title={`${naoLidos} aviso(s) não lido(s)`}
      aria-label={`${naoLidos} avisos não lidos`}
    >
      {naoLidos > 99 ? '99+' : naoLidos}
    </span>
  );
}
